
import Profile from "views/Profile/profile.jsx";
import Balances from "views/Balances/balances.jsx";
import BalancesHistorical from "views/Balances/balanceshistorical.jsx";
import NewPayout from "views/Payouts/new-payout.jsx";
import Payouts from "views/Payouts/payouts.jsx";
import PayoutsSearch from "views/Payouts/payouts-search.jsx";
import Deposits from "views/Funding/deposits.jsx";
import DepositSearchref from "views/Funding/deposit-search-ref.jsx";
import DepositSearchtx from "views/Funding/deposit-search-tx.jsx";
import Addresses from "views/Funding/addresses.jsx";
//import verify2fa from "views/Settings/2fa.jsx";
import Settings from "views/Settings/Settings.jsx";




import pagesRoutes from "./pages.jsx";


var dashboardRoutes = [
  

  {
    collapse: true,
  menuhide:false,
  state: "openBalances",
  name: "Account Balances",
  icon: "fal fa-balance-scale",
  
  views: [
    {
      menuhide:false,
      path: "/account_balances/current",
      name: "Current",
      icon: "fal fa-balance-scale",
      component: Balances
    },
    {
      menuhide:false,
      path: "/account_balances/historical",
      name: "Historical",
      icon: "fal fa-balance-scale",
      component: BalancesHistorical
    }]
  },{
    collapse: true,
  menuhide:false,
  state: "payouts",
  name: "Payouts",
  icon: "fal fa-file-invoice-dollar",
  
  views: [
    {
      menuhide:false,
      path: "/new_payout",
    name: "New Payout",
    icon: "fal fa-file-invoice-dollar",
    component: NewPayout
    },  {
      menuhide:false,
      path: "/payout_history",
    name: "Payout History",
    icon: "fal fa-file-invoice-dollar",
    component: Payouts
    },
    {
      menuhide:false,
      path: "/payout search",
      name: "Payout Search",
      icon: "fal fa-hand-holding-usd",
      component: PayoutsSearch
    }]
  },
  ,{
    collapse: true,
  menuhide:false,
  state: "funding",
  name: "Funding",
  icon: "fal fa-hand-holding-usd",
  
  views: [
    {
      menuhide:false,
      path: "/deposits_received",
    name: "Deposits Received",
      icon: "fal fa-hand-holding-usd",
      component: Deposits
    },
    {
      menuhide:false,
      path: "/deposit_search_ref",
      name: "Deposit Search By Ref ID",
      icon: "fal fa-hand-holding-usd",
      component: DepositSearchref
    }, {
      menuhide:false,
      path: "/deposit_search_tx",
      name: "Deposit Search By TX Hash",
      icon: "fal fa-hand-holding-usd",
      component: DepositSearchtx
    },{
 
    path: "/deposit_addresses",
    name: "Deposit Addresses",
    icon: "fal fa-wallet",
    component: Addresses
   
   
  }]
  },
      {
        menuhide:true,
        path: "/profile",
        name: "Profile",
        component: Profile
      },
     
      {
 
        path: "/settings",
        name: "Settings",
        icon: "fal fa-cog",
        component: Settings
       
      },

      
      
  { redirect: true, path: "/", pathTo: "/account_balances/current", name: "Home" }


];
export default dashboardRoutes;
